import { api } from '../../../api-helper';
import { URLS } from '../../../../constants/URLS';
export const getDocumentsList = (orderId, projectID, pdfOnly, body = {}) => {
  return api.post(URLS.documents, body, {
    params: {
      ...(orderId && { orderID: orderId }),
      ...(projectID && { projectID: projectID }),
      ...(pdfOnly && { pdfOnly: pdfOnly })
    },

    headers: {
      needsToken: true
    }
  });
};

export const uploadOrderDocuments = (orderId, formData) => {
  return api.post(URLS.uploadOrderDocuments, formData, {
    params: {
      ...(orderId && { orderID: orderId })
    },
    headers: {
      needsToken: true
    }
  });
};

export const getDocumentsSortList = () => {
  return api.get(URLS.documentsSortList, {
    headers: {
      needsToken: true
    }
  });
};

export const getDocumentsFilterList = () => {
  return api.get(URLS.documentsFilterList, {
    headers: {
      needsToken: true
    }
  });
};

export const getAttachmentTypeCategories = () => {
  return api.get(URLS.attachmentTypeCategories, {
    headers: {
      needsToken: true
    }
  });
};

export const deleteDocument = (fileId, orderID) => {
  return api.delete(URLS.deleteDocument, {
    params: {
      ...(fileId && { id: fileId }),
      ...(orderID && { orderID: orderID })
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateDocumentList = (data, fileId) => {
  return api.put(URLS.updateDocument + `?id=${fileId}`, data, {
    headers: {
      needsToken: true
    }
  });
};

export const mergePdf = (orderId, formData) => {
  return api.post(`${URLS.mergePdf}?id=${orderId}`, formData, {
    responseType: 'blob',
    headers: {
      needsToken: true
    }
  });
};
